<template>
    <div class="main-cotent">
        <div class="export-btn">
<!--            <el-button @click="exportSelect">导出筛选</el-button>-->
            <el-button   icon="el-icon-download"  @click="exportSelect">导出全部</el-button>
            <el-button   icon="el-icon-download"  @click="exportChecked" :disabled="selected.length == 0"
            >导出选中</el-button
            >
            <el-button   type="primary"  :disabled="selected.length == 0" @click="handleBatchCancel">批量取消</el-button>
<!--            <el-button-->
<!--                    type="primary"-->
<!--                    @click="batchApprove"-->
<!--                    :disabled="selected.length == 0"-->
<!--            >批量审核</el-button-->
<!--            >-->
            <el-button

                    type="primary"
                    @click="batchBilling"
                    :disabled="selected.length == 0"
            >批量标记已开票</el-button
            >
            <el-button icon="el-icon-upload" style="background: #409EFF"  type="primary" @click="openUploadModal">电子开票上传</el-button>
            <el-button icon="el-icon-circle-plus"   type="primary" @click="openModal">创建申请单</el-button>
        </div>
        <div class="contentlist">
<!--            <vs-table multiple v-model="selected" :data="list" noDataText="暂无数据">-->
<!--                <template slot="thead">-->
<!--                    <vs-th-->
<!--                            :class="orderThStyle(headData)"-->
<!--                            v-for="(headData, index) in headData"-->
<!--                            :key="index"-->
<!--                    >{{ headData }}</vs-th-->
<!--                    >-->
<!--                </template>-->

<!--                <template slot-scope="{ data }">-->
<!--                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">-->
<!--                        <vs-td style="width: 50px">-->
<!--                            <p>-->
<!--                                {{ indextr + 1 }}-->
<!--                            </p>-->
<!--                        </vs-td>-->

<!--                        <vs-td :data="tr.invoiceNo" style="width: 100px">-->
<!--                            <p>{{ tr.invoiceNo }}</p>-->
<!--                        </vs-td>-->

<!--                        <vs-td :data="tr.invoiceTime" style="width: 120px">-->
<!--                            <p>{{ tr.invoiceTime}}</p>-->
<!--                        </vs-td>-->

<!--                        <vs-td :data="tr.customerName" style="width: 200px">-->
<!--                            <p>-->
<!--                                <span v-if="tr.customerName">{{ tr.customerName }}</span>-->
<!--                                <span v-if="tr.customerCode">/{{ tr.customerCode }}</span>-->
<!--                            </p>-->
<!--                        </vs-td>-->
<!--                        <vs-td :data="tr.invoiceMoney" style="width: 60px">-->
<!--                            <p>{{ tr.invoiceMoney }}</p>-->
<!--                        </vs-td>-->

<!--                        <vs-td :data="tr.business" style="width: 100px">-->
<!--                            <p>{{ tr.business }}</p>-->
<!--                        </vs-td>-->

<!--                        <vs-td :data="tr.bodyName" style="width: 160px">-->
<!--                            <p>{{ tr.bodyName }}</p>-->
<!--                        </vs-td>-->

<!--                        <vs-td :data="tr.corporateName" style="width: 160px">-->
<!--                            <p>{{ tr.corporateName }}:{{ tr.corporateTaxNumber }}</p>-->
<!--                        </vs-td>-->
<!--                        <vs-td :data="tr.corporateBank" style="width: 160px">-->
<!--                            <p>{{ tr.corporateBank }}:{{ tr.corporateBankNumber }}</p>-->
<!--                        </vs-td>-->
<!--                        <vs-td :data="tr.address" style="width: 160px">-->
<!--                            <p>{{ tr.address }}</p>-->
<!--                        </vs-td>-->
<!--                        <vs-td :data="tr.invoiceType" style="width: 160px">-->
<!--                            <p>{{ tr.invoiceType ==='1'?'普通发票':(tr.invoiceType === '2'?'增值税专用发票':'&#45;&#45;') }}</p>-->
<!--                        </vs-td>-->
<!--                        <vs-td :data="tr.invoicingType" style="width: 160px">-->
<!--                            <p>{{ tr.invoicingType ==='electronic'?'电子发票':(tr.invoicingType === 'paper'?'纸质发票':'&#45;&#45;') }}</p>-->
<!--                        </vs-td>-->
<!--                        <vs-td :data="tr.invoiceStatus" style="width: 160px;">-->
<!--                            <p style="color:#909399;font-weight: bold" v-show="tr.invoiceStatus === 'TO_REVIEWED'">待确认</p>-->
<!--                            <p style="color:#F56C6C;font-weight: bold" v-show="tr.invoiceStatus === 'CANCEL'">已取消</p>-->
<!--                            <p style="color:#409EFF;font-weight: bold" v-show="tr.invoiceStatus === 'TO_INVOICED'">待开票</p>-->
<!--                            <p style="color:#67C23A;font-weight: bold" v-show="tr.invoiceStatus === 'INVOICED'">已开票</p>-->
<!--                        </vs-td>-->

<!--                        <vs-td style="width: 100px" class="flex-box fixed-table-column">-->
<!--                            <a @click="goDetail(tr)" style="margin-right: 5px">查看</a>-->
<!--                            &lt;!&ndash; <a-->
<!--                              v-if="tr.invoiceStatus == 'FAIL'"-->
<!--                              href="javascript:;"-->
<!--                              @click="againApprove(tr)"-->
<!--                              >重新审核</a-->
<!--                            > &ndash;&gt;-->
<!--                            <a-->
<!--                                    v-if="tr.invoiceStatus == 'TO_INVOICED'"-->
<!--                                    href="javascript:;"-->
<!--                                    @click="invoicing(tr)"-->
<!--                            >开票</a-->
<!--                            >-->
<!--                            &lt;!&ndash; <a-->
<!--                              v-if="tr.invoiceStatus == 'INVOICED'"-->
<!--                              href="javascript:;"-->
<!--                              @click="withdraw(tr)"-->
<!--                              >撤回</a-->
<!--                            > &ndash;&gt;-->
<!--                        </vs-td>-->
<!--                    </vs-tr>-->
<!--                </template>-->
<!--            </vs-table>-->

            <el-table size="small" :cell-style="{'text-align':'center'}"  :header-cell-style="{background:'#f5f7fa','text-align':'center',color:'#606266'}"  stripe  ref="multipleTable" @selection-change="handleSelectionChange" style="width: 100%;margin-top: 20px;" border :data="list">
                <el-table-column  type="selection" width="55"></el-table-column>
                <el-table-column width="55" label="序号">
                    <template slot-scope="scope">{{scope.$index+1}}</template>
                </el-table-column>
                <el-table-column width="150"  label="申请编号" prop="invoiceNo"></el-table-column>
                <el-table-column width="150"  label="申请时间" prop="invoiceTime"></el-table-column>
                <el-table-column width="300"  label="申请客户" prop="customerName">
                    <template slot-scope="scope">{{scope.row.customerName}}/{{scope.row.customerCode}}</template>
                </el-table-column>
                <el-table-column width="80"  label="开票金额" prop="invoiceMoney"></el-table-column>
                <el-table-column width="150"  label="经营范围" prop="business"></el-table-column>
                <el-table-column width="80"  label="开票主体" prop="bodyName"></el-table-column>
                <el-table-column width="200"  label="开票信息" prop="corporateName">
                    <template slot-scope="scope">{{scope.row.corporateName}}:{{scope.row.corporateTaxNumber}}</template>
                </el-table-column>
                <el-table-column width="200"  label="开户行信息" prop="corporateBank">
                    <template slot-scope="scope">
                        <div v-if="scope.row.invoiceType === '2'">{{scope.row.corporateBank}}{{scope.row.corporateBankNumber?':'+scope.row.corporateBankNumber:'--'}}</div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column width="200"  label="收件信息" prop="address">
                    <template slot-scope="scope">
                        {{scope.row.invoicingType === 'paper'?scope.row.address:(scope.row.invoicingType === 'electronic'?scope.row.email:'--')}}
                        </template>
                </el-table-column>
                <el-table-column width="80"  label="开票类型" prop="invoiceType">
                    <template slot-scope="scope">{{ scope.row.invoiceType ==='1'?'普通发票':(scope.row.invoiceType === '2'?'增值税专用发票':'--') }}</template>
                </el-table-column>
                <el-table-column width="80"  label="开票形式" prop="invoicingType">
                    <template slot-scope="scope">{{ scope.row.invoicingType ==='electronic'?'电子发票':(scope.row.invoicingType === 'paper'?'纸质发票':'--') }}</template>
                </el-table-column>
                <el-table-column   fixed="right" width="100" label="申请状态" prop="invoiceStatus">
                    <template slot-scope="scope">
                        <p style="color:#909399;font-weight: bold" v-show="scope.row.invoiceStatus === 'TO_REVIEWED'">待确认</p>
                        <p style="color:#F56C6C;font-weight: bold" v-show="scope.row.invoiceStatus === 'CANCEL'">已取消</p>
                        <p style="color:#409EFF;font-weight: bold" v-show="scope.row.invoiceStatus === 'TO_INVOICED'">待开票</p>
                        <p style="color:#67C23A;font-weight: bold" v-show="scope.row.invoiceStatus === 'INVOICED'">已开票</p>
                    </template>
                </el-table-column>
                <el-table-column  fixed="right" width="110"  label="操作">
                    <template slot-scope="scope">
                        <a style="cursor: pointer;margin-right: 5px;font-weight: 500;" @click="goDetail(scope.$index, scope.row)">查看</a>
                        <a style="margin-right: 5px;font-weight: 500;" v-if="scope.row.invoiceStatus == 'TO_INVOICED'" href="javascript:;" @click="invoicing(scope.$index, scope.row)">开票</a>
                        <a style="color: #F56C6C;font-weight: 500;" v-if="scope.row.invoiceStatus == 'TO_REVIEWED'" href="javascript:;" @click="handleCancel(scope.$index, scope.row)">取消</a>
                    </template>
                </el-table-column>

            </el-table>
        </div>
        <gc-vs-pagination
                v-if="pageShow"
                :pager="pagination"
                totalName="totalCount"
                pageNoName="pagerNo"
                pageSizeName="pageSize"
                @handleSizeChange="handleSizeChange"
                @handleCurrentChange="handleCurrentChange"
        ></gc-vs-pagination>
        <!--电子发票上传弹窗-->
        <el-dialog title="电子发票上传" append-to-body width="40%" :visible.sync="uploadModal"  :before-close="closeModal">
           <div style="text-align: center">
               <el-upload
                       :on-success="handleSuccess"
                       :headers="headers"
                       :limit="1"
                       drag
                       :file-list="invoiceFileList"
                       :before-upload="beforeAvatarUpload"
                       accept=".zip"
                       action="/data-dist/api/dist/invoice/info/upload"
                       >
                   <i class="el-icon-upload"></i>
                   <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                   <div class="el-upload__tip" slot="tip">只能上传ZIP压缩包文件，且不超过50MB</div>
    </el-upload>
    </div>

        </el-dialog>
        <!-- 审核 -->
        <el-dialog
                title="审核"
                :visible.sync="dialogVisible"
                width="30%"
                height="500px"
                :before-close="handleClose"
                class="dia-box"
        >
            <div style="padding: 0 20px">
                <div style="display: flex">
                    <p class="p1">审批单据：</p>
                    <div class="auto-box">
                        <p
                                style="font-weight: 500; padding: 0 10px"
                                v-for="(item, index) in rowData.list"
                                :key="index"
                        >
                            {{ item }}
                        </p>
                    </div>
                </div>
                <div style="display: flex">
                    <p class="p1">审批备注：</p>
                    <div style="width: 72%; margin-left: 10px">
                        <el-input
                                type="textarea"
                                placeholder="请输入"
                                v-model="note"
                                maxlength="200"
                                show-word-limit
                                :rows="5"
                        >
                        </el-input>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button @click="approveSucc" type="primary">同意</el-button>
        <el-button @click="approveFail" type="danger">驳回</el-button>
      </span>
        </el-dialog>

        <!-- 开票 -->
        <el-dialog
                title="开票"
                :visible.sync="dialogVisible1"
                width="50%"
                height="500px"
                :before-close="handleClose1"
                class="dia-box"
        >
            <div style="padding: 0 20px">
                <div style="display: flex; margin-bottom: 20px">
<!--                    <p class="p1">开票单据：</p>-->
<!--                    <div class="auto-box">-->
<!--                        <p-->
<!--                                style="font-weight: 500; padding: 0 10px; line-height: 30px"-->
<!--                                v-for="(item, index) in rowData.list"-->
<!--                                :key="index"-->
<!--                        >-->
<!--                            {{ item }}-->
<!--                        </p>-->
<!--                    </div>-->
                </div>
                <div style="display: flex">
                    <p class="p1">开票备注：</p>
                    <div style="width: 72%; margin-left: 10px">
                        <el-input
                                type="textarea"
                                placeholder="请输入"
                                v-model="invoiceNote"
                                maxlength="200"
                                show-word-limit
                                :rows="5"
                        >
                        </el-input>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取消</el-button>
        <el-button @click="invoicingSure" type="primary">确认</el-button>
      </span>
        </el-dialog>

        <!-- 批量开票 -->
        <el-dialog
                title="批量标记开票"
                :visible.sync="dialogVisible2"
                width="40%"
                height="200px"
                :before-close="handleClose2"
                class="dia-box"
        >
            <div style="padding: 0 20px; line-height: 30px">
                <el-table size="mini" border :data="invoiceTable" style="width: 100%">
                    <el-table-column prop="code" label="发票编号"></el-table-column>
                </el-table>
            </div>
            <div style="padding: 0 20px;margin-top: 15px;">
                <el-input
                        type="textarea"
                        :rows="2"
                        placeholder="请输入开票备注"
                        v-model="batchRemark">
                </el-input>
            </div>

            <span slot="footer" style="margin-top: 20px">
        <!-- <el-button @click="batchApproveSucc" >取消</el-button>
        <el-button @click="batchApproveFail" type="primary">确认</el-button> -->
        <el-button @click="dialogVisible2 = false">取消</el-button>
        <el-button @click="batchBillingSure('batch')" type="primary">确认</el-button>
      </span>
        </el-dialog>

        <invoiceDetail ref="invoiceDetail" @refresh="getList"></invoiceDetail>
        <!--创建申请单-->
        <el-drawer
                title="申请单创建"
                :before-close="handleFormClose"
                :visible.sync="formDialog"
                direction="rtl"
                custom-class="demo-drawer"
                ref="drawer"
        >
            <div class="form-container">
                <el-form :model="form" ref="form" label-suffix=":" label-width="105px" label-position="left">
                    <el-form-item label="选择开票主体">
                        <el-checkbox-group v-model="form.bodyId">
                            <el-checkbox v-for="(item,index) in bodyList"  :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="发货时间">
                        <el-date-picker
                                style="width: 100%"
                                size="small"
                                v-model="form.createTime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="选择客户">
                     <el-select v-model="form.val" @change="handleKh" style="width: 100%" size="small">
                         <el-option label="客户类型" :value="1">客户类型</el-option>
                         <el-option label="手动输入" :value="2">手动输入</el-option>
                     </el-select>
                    </el-form-item>
                    <el-form-item>
                        <div v-show="form.val === 1">
                            <el-checkbox-group v-model="form.customerCodes">
                                <el-checkbox style="width: 100%" @change="handleCustomer(item)" v-for="(item,index) in customerList" :key="item.code" :label="item.code">{{item.name}}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div v-show="form.val === 2">
                            <el-select
                                    style="width: 100%"
                                    v-model="khValue"
                                    multiple
                                    filterable
                                    remote
                                    reserve-keyword
                                    placeholder="请输入客户编码/名称"
                                    :remote-method="remoteMethod"
                                    :loading="khLoading">
                                <el-option
                                        v-for="item in khOptions"
                                        :key="item.code"
                                        :label="item.name"
                                        :value="item.code">
                                </el-option>
                            </el-select>
                        </div>
                    </el-form-item>
                </el-form>
                <div class="form-footer">
                    <el-button @click="handleFormClose">取 消</el-button>
                    <el-button type="primary" @click="submitForm" :loading="submitLoading">{{ submitLoading ? '提交中 ...' : '确 定' }}</el-button>
                </div>
            </div>
        </el-drawer>

    </div>
</template>

<script>
    import {Local_Storage} from "@/store/local.storage";
    import invoiceDetail from "./details";
    import { downloadExcel } from "@/utils/downloadExcel.js";
    import { invoiceApi } from "@/modules/server-api/invoice";
    import GcCmpVsTable from "@/group-cloud/components/vsTable";
    import VsTable from "./vsTable/vsTable";
    import VsTd from "./vsTable/vsTd";
    import VsTh from "./vsTable/vsTh";
    import VsTr from "./vsTable/vsTr";
    export default {
        components: {
            GcCmpVsTable,
            VsTable,
            VsTd,
            VsTh,
            VsTr,
            invoiceDetail,
        },
        props: {},
        data() {
            return {
                invoiceFileList:[],
                uploadModal:false,
                headers:{},
                batchRemark:'',
                invoiceTable:[],
                khFlag:null,
                customerList:[],//客户类型列表
                bodyList:[],//开票主体列表
                submitLoading:false,
                khOptions: [],
                khValue: [],
                khList: [],
                khLoading: false,
                form:{
                    customerNames:[],
                    bodyId:[],
                    bodyName:[],
                    createTime:[],
                    endTime:'',
                    operationId:null,
                    operationName:'',
                    customerCodes:[],
                    customerTypes:[],
                },//申请单表单
                formDialog:false,//申请单标识显示
                invoiceNos: [], //选择的发票编号
                rowData: [],
                note: "", //审核备注
                invoiceNote: "", //开票备注
                approveData: [], //审批数据
                invoiceData: [], //开票数据
                showFlag: false, //详情弹框
                pageShow: true,
                dialogVisible2: false, //批量审核
                dialogVisible: false, //单个审核
                dialogVisible1: false, //开票
                selectTJ: {
                    bodyId: '',
                    beginDate: '',
                    endDate: '',
                    customerCode: '',
                    customerName: '',
                    invoiceStatus:'',
                    invoiceType: '',
                }, //筛选条件
                selected: [],
                seq: 0,
                keyword: "",
                pagination: {
                    // 分页
                    pageNo: 1,
                    pageSize: 20,
                    totalCount: 0,
                },
                list: [],
                operationId: "",
                operationName: "",
                headData: [
                    "序号",
                    "申请编号",
                    "申请时间",
                    "申请客户",
                    "开票金额",
                    "经营范围",
                    "开票主体",
                    "开票信息",
                    "开户行信息",
                    "收件信息",
                    "开票类型",
                    "开票形式",
                    "申请状态",
                    "操作",
                ],
            };
        },
        created() {
            this.getList();
            let userInfo = JSON.parse(localStorage.getItem("user_state"));
            this.operationId = userInfo.userId;
            this.operationName = userInfo.name;
            let savedSession = Local_Storage.getSession();
            let token = savedSession.token || '';
            this.headers={Authorization:token}

        },
        mounted() {

        },
        methods: {
            //压缩包格式校验
            beforeAvatarUpload(file){
                let typeArr = ['application/zip','application/x-zip-compressed','application/x-zip'];
                let isZip = typeArr.includes(file.type);
                let is50M = file.size / 1024 / 1024 < 50;
                let isRar = file.type.split(".")[1] === 'rar';
                if (!isZip) {
                    this.$message.error('请上传zip压缩包!');
                    return false;
                }
                if (isRar) {
                    this.$message.error('请上传zip压缩包!');
                    return  false;
                }
                if (!is50M) {
                    this.$message.error('压缩包大小不能超过50MB!');
                    return false;
                }
            },
            closeModal(){
              this.uploadModal = false;
            },
            handleSuccess(res,file,fileList){
                if(res.succ === 1){
                    this.$message.success('上传成功');
                    this.uploadModal = false;
                    this.getList();
                }else{
                    this.$message.error(res.error);
                }
                this.invoiceFileList = [];
            },
            //打开电子发票上传弹窗
            openUploadModal(){
              this.uploadModal = true;
            },
            //选择客户类型
            handleCustomer(val){
                console.log(val);
               if(this.form.customerNames.indexOf(val.name) === -1){
                   this.form.customerNames.push(val.name)
               }else{
                   this.form.customerNames.splice(this.form.customerNames.indexOf(val.name),1);
               }

            },
            //获取开票主体
            getBodyList(){
                invoiceApi.getInvoiceBody().then(res=>{
                    if(res.succ === 1){
                        this.bodyList = res.result;
                    }else{
                        this.$notifyError('获取开票主体失败')
                    }
                })
            },
            //模糊检索客户名称
            remoteMethod(query) {
                if (query !== '') {
                    this.khLoading = true;
                    let formData = new FormData();
                    formData.append('param',query);
                    invoiceApi.getClient(formData).then(res=>{
                        this.khLoading = false;
                        this.khOptions = res.result.slice(0,30);
                    })
                } else {
                    this.khOptions = [];
                }
            },
            //选择客户
            handleKh(val){
                if(val === 1){ //客户类型
                    this.khFlag = true; //客户checkbox：true,模糊搜索为false
                    this.form.customerCodes = [];
                    this.khOptions = [];
                    this.khValue = [];
                    invoiceApi.getCustomerType().then(res=>{
                        this.customerList = res.result;
                    })
                }else{  //手动模糊搜索
                    this.khFlag = false;
                    this.customerList = [];
                }
            },
            handleFormClose(){
                this.form = {
                    customerNames: [],
                    bodyId: [],
                    bodyName: [],
                    createTime: [],
                    endTime: '',
                    operationId: null,
                    operationName: '',
                    customerCodes: [],
                    customerTypes: [],
                }
                this.customerList = [];
                this.khOptions = [];
                this.khValue = [];
                this.pagination.pageNo = 1;
                this.pagination.pageSize = 20;
                this.formDialog = false;
            },
            submitForm(){
                if(this.form.bodyId.length === 0){
                    this.$notifyError('请选择开票主体');
                    return false;
                }
                if(this.form.createTime.length === 0){
                    this.$notifyError('请选择发货时间');
                    return false;
                }
                if(this.khFlag === null){
                    this.$notifyError('请选择客户');
                    return false;
                }
                if(this.khFlag === true && this.form.customerCodes.length === 0){
                    this.$notifyError('请选择客户');
                    return false;
                }
                if(this.khFlag === false && this.khValue.length === 0){
                    this.$notifyError('请选择客户');
                    return false;
                }

                if(this.bodyList.length>0){
                    this.bodyList.forEach(item=>{
                        if(this.form.bodyId.includes(item.id) && !this.form.bodyName.includes(item.name)){
                            this.form.bodyName.push(item.name)
                        }
                    })
                }
                let customerCodes = [];  //客户编码
                let customerTypes = []; //客户名称

                if(this.khFlag === true){ //
                    customerCodes = JSON.parse(JSON.stringify(this.form.customerCodes));
                    customerTypes = JSON.parse(JSON.stringify(this.form.customerNames));
                }else{
                    customerCodes = JSON.parse(JSON.stringify(this.khValue));
                    if(this.khOptions.length>0){
                        this.khOptions.forEach(item=>{
                              if(customerCodes.includes(item.code)){
                                  customerTypes.push(item.name);
                              }
                        })
                    }

                }
                let params = {
                    bodyId:this.form.bodyId.join(','),
                    bodyName:this.form.bodyName.join(','),
                    createTime:this.form.createTime[0],
                    endTime:this.form.createTime[1],
                    operationId:JSON.parse(sessionStorage.getItem('user_state')).userId,
                    operationName:JSON.parse(sessionStorage.getItem('user_state')).name,
                    customerCodes:customerCodes,
                    customerTypes:customerTypes,
                }
                this.submitLoading = true;
                invoiceApi.submitApply(params).then(res=>{
                    if(res.succ === 1){
                        this.$notifySuccess(res.result);
                        this.$refs.form.resetFields();
                        this.customerList = [];
                        this.khOptions = [];
                        this.khValue = [];
                        this.form = {
                            customerNames: [],
                            bodyId: [],
                            bodyName: [],
                            createTime: [],
                            endTime: '',
                            operationId: null,
                            operationName: '',
                            customerCodes: [],
                            customerTypes: [],
                        };//申请单表单
                        this.pagination.pageNo = 1;
                        this.pagination.pageSize = 20;
                        this.formDialog = false;
                        this.getList();

                    }
                }).finally(e=>{
                    this.submitLoading = false;
                })
            },
            //去掉按钮点击后焦点问题
            noFocus(evt){
                let target = evt.target;
                if(target.nodeName == "SPAN"){
                    target = evt.target.parentNode;
                }
                target.blur();
            },

            //打开申请单弹窗
            openModal(evt){
              this.noFocus(evt);
              this.formDialog = true;
              this.getBodyList();
            },
            orderThStyle(thname) {
                let style = "";
                if (thname == "开票金额") {
                    style = "text-centr";
                } else if (thname == "操作") {
                    style = "fixed-table-column";
                }
                return style;
            },
            goDetail(index,row) {
                // this.$router.push({
                //   path: "/modules/invoice/view",
                //   query: {
                //     invoiceNo: row.invoiceNo,
                //   },
                // }).catch(()=>{});
                this.$refs.invoiceDetail.detailLoading = true;
                this.$refs.invoiceDetail.getData(row);
            },
            //导出选中
            exportChecked(evt) {
                this.noFocus(evt);
                console.log(this.selected);
                let invoiceNos = this.selected.map((v) => {
                    return v.invoiceNo;
                });
                let params = {
                    type: "IDS",
                    invoiceNos: invoiceNos.join(","),
                };
                let url = "/data-dist/api/dist/invoice/info/push";
                let fileName = "发票管理列表.xlsx";
                downloadExcel(url, params, fileName);
            },

            //导出筛选
            exportSelect(evt) {
                this.noFocus(evt);
                let params = {
                    type: "CONDITION",
                    bodyId: this.selectTJ.bodyId,
                    beginDate: this.selectTJ.beginDate,
                    endDate: this.selectTJ.endDate,
                    customerCode: this.selectTJ.customerCode,
                    customerName: this.selectTJ.customerName,
                    invoiceStatus: this.selectTJ.invoiceStatus,
                    invoiceType: this.selectTJ.invoiceType,
                };
                let url = "/data-dist/api/dist/invoice/info/push";
                let fileName = "发票管理列表.xlsx";
                downloadExcel(url, params, fileName);
            },

            //批量审核
            batchApprove() {
                let flag = this.selected.every((v) => {
                    return v.invoiceStatus == "TO_REVIEWED";
                });
                console.log(this.selected, flag, "=========");
                if (!flag) {
                    this.$notify({
                        type: "warning",
                        message: "所选的发票中含有当前状态不符合的发票，无法审核",
                    });
                } else {
                    this.dialogVisible2 = true;
                    this.invoiceNos = this.selected.map((v) => {
                        return v.invoiceNo;
                    });
                }
            },
            //单个取消
            handleCancel(index,row){
                let tips = "是否取消编号" + row.invoiceNo + "，请谨慎操作！";
                this.$confirm(tips, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(()=>{
                    let params = {
                        invoiceNos: row.invoiceNo,
                        operation: "CANCEL",
                        operationId:JSON.parse(sessionStorage.getItem('user_state')).userId,
                        operationName:JSON.parse(sessionStorage.getItem('user_state')).name,
                    };
                    invoiceApi.approve(params).then(res=>{
                        if(res.succ == 1){
                            this.$notifySuccess('取消成功');
                            this.getList();
                        }else{
                            this.$message({
                                type: "error",
                                message: res.error,
                            });
                        }
                    })
                }).catch(()=>{

                })
            },
            //批量取消
            handleBatchCancel(evt){
                this.noFocus(evt);
                let flag = this.selected.every((v) => {
                    return v.invoiceStatus == "TO_REVIEWED";
                });
                if(!flag){
                    this.$notify({
                        type: "error",
                        message: "所选的发票中含有当前状态不符合的发票，无法取消",
                    });
                }else{
                    this.cancelFun();
                }
            },
            cancelFun(){
                let invoiceNos = this.selected.map((v) => {
                    return v.invoiceNo;
                });
                let tips = "是否取消编号" + invoiceNos.join(",") + "，请谨慎操作！";
                this.$confirm(tips, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(()=>{
                    let params = {
                        invoiceNos: invoiceNos.join(","),
                        operation: "CANCEL",
                        invoiceNote:this.invoiceNote,
                        operationId:JSON.parse(sessionStorage.getItem('user_state')).userId,
                        operationName:JSON.parse(sessionStorage.getItem('user_state')).name,
                    };
                    invoiceApi.approve(params).then(res=>{
                        if(res.succ == 1){
                            this.$notifySuccess('取消成功');
                            this.getList();
                        }else{
                            this.$message({
                                type: "error",
                                message: res.error,
                            });
                        }
                    })
                }).catch(()=>{

                })
            },
            //批量开票
            batchBilling(evt) {
                this.noFocus(evt);
                let flag = this.selected.every((v) => {
                    return v.invoiceStatus == "TO_INVOICED";
                });
                console.log(this.selected, flag, "=========");
                if (!flag) {
                    this.$notify({
                        type: "error",
                        message: "所选的发票中含有当前状态不符合的发票，无法开票",
                    });
                } else {
                    this.dialogVisible2 = true;
                    this.invoiceNos = this.selected.map((v) => {
                        return v.invoiceNo;
                    });
                    this.invoiceTable = this.invoiceNos.map(item=>{
                        return {
                            code:item
                        }
                    })
                }
            },
            batchBillingSure(type) {
                let invoiceNos = this.selected.map((v) => {
                    return v.invoiceNo;
                });
                let tips = "是否为当前发票编号开票，请谨慎操作！";
                this.$confirm(tips, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        let params = {
                            invoiceNos: invoiceNos.join(","),
                            operation: "INVOICED",
                            invoiceNote:type === 'batch'?this.batchRemark:this.invoiceNote,
                            operationId:JSON.parse(sessionStorage.getItem('user_state')).userId,
                            operationName:JSON.parse(sessionStorage.getItem('user_state')).name,
                        };
                        invoiceApi.approve(params).then((res) => {
                            if (res.succ) {
                                this.$message({
                                    type: "success",
                                    message: "操作成功！",
                                });
                                if(type === 'batch'){
                                    this.dialogVisible2 = false;
                                    this.batchRemark = '';
                                }
                                this.getList();
                            } else {
                                this.$message({
                                    type: "error",
                                    message: res.error,
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },

            //批量标记成功
            batchApproveSucc(tr) {
                let invoiceNos = this.selected.map((v) => {
                    return v.invoiceNo;
                });
                let params = {
                    type: "BATCH",
                    invoiceNos: invoiceNos.join(","),
                    operation: "REVIEWED",
                    operationId:JSON.parse(sessionStorage.getItem('user_state')).userId,
                    operationName:JSON.parse(sessionStorage.getItem('user_state')).name,
                };
                invoiceApi.approve(params).then((res) => {
                    if (res.succ) {
                        this.$message({
                            type: "success",
                            message: "操作成功！",
                        });
                        this.getList();
                    } else {
                        this.$message({
                            type: "error",
                            message: res.error,
                        });
                    }
                    this.dialogVisible2 = false;
                });
            },
            //批量审核失败
            batchApproveFail(tr) {
                let invoiceNos = this.selected.map((v) => {
                    return v.invoiceNo;
                });
                let params = {
                    type: "BATCH",
                    invoiceNo: invoiceNos.join(","),
                    operation: "FAIL",
                    operationId:JSON.parse(sessionStorage.getItem('user_state')).userId,
                    operationName:JSON.parse(sessionStorage.getItem('user_state')).name,
                };
                invoiceApi.approve(params).then((res) => {
                    if (res.succ) {
                        this.$message({
                            type: "success",
                            message: "操作成功！",
                        });
                        this.getList();
                    } else {
                        this.$message({
                            type: "error",
                            message: res.error,
                        });
                    }
                    this.dialogVisible = false;
                });
            },

            handleClose() {
                this.dialogVisible = false;
            },
            handleClose2() {
                this.dialogVisible2 = false;
            },
            handleClose1() {
                this.dialogVisible1 = false;
            },
            handleSelectionChange(val){
                this.selected = val;
            },
            //重新审核
            againApprove(index,tr) {
                let params = {
                    type: "ONLY",
                    invoiceNo: tr.invoiceNo,
                    operation: "TO_REVIEWED",
                    operationId:JSON.parse(sessionStorage.getItem('user_state')).userId,
                    operationName:JSON.parse(sessionStorage.getItem('user_state')).name,
                };
                invoiceApi.approve(params).then((res) => {
                    if (res.succ) {
                        this.$message({
                            type: "success",
                            message: "操作成功！",
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: res.error,
                        });
                    }
                });
            },
            invoicing(index,tr) {
                console.log(index,tr);
                this.dialogVisible1 = true;
                this.rowData = tr;
            },
            //开票
            invoicingSure(tr) {
                console.log(this.rowData);
                // this.$confirm("请确认是否开票？", "提示", {
                //   confirmButtonText: "确定",
                //   cancelButtonText: "取消",
                //   type: "warning",
                // })
                //   .then(() => {
                let params = {
                    invoiceNos: this.rowData.invoiceNo,
                    operation: "INVOICED",
                    operationId:JSON.parse(sessionStorage.getItem('user_state')).userId,
                    operationName:JSON.parse(sessionStorage.getItem('user_state')).name,
                    invoiceNote: this.invoiceNote,
                };
                invoiceApi.approve(params).then((res) => {
                    if (res.succ) {
                        this.$message({
                            type: "success",
                            message: "操作成功！",
                        });

                        this.getList();
                    } else {
                        this.$message({
                            type: "error",
                            message: res.error,
                        });
                    }
                    this.dialogVisible1 = false;
                    this.invoiceNote = "";
                });
                // })
                // .catch(() => {});
            },
            //审核
            approve(tr) {
                this.dialogVisible = true;
                this.rowData = tr;
            },
            //审核成功
            approveSucc(tr) {
                let params = {
                    type: "ONLY",
                    invoiceNo: this.rowData.invoiceNo,
                    operation: "REVIEWED",
                    operationId:JSON.parse(sessionStorage.getItem('user_state')).userId,
                    operationName:JSON.parse(sessionStorage.getItem('user_state')).name,
                    note: this.note,
                };
                invoiceApi.approve(params).then((res) => {
                    if (res.succ) {
                        this.$message({
                            type: "success",
                            message: "操作成功！",
                        });
                        this.getList();
                    } else {
                        this.$message({
                            type: "error",
                            message: res.error,
                        });
                    }
                    this.dialogVisible = false;
                    this.note = "";
                });
            },
            //审核失败
            approveFail(tr) {
                if (this.note == "" || this.note.split(" ").join("").length == 0) {
                    this.$message({
                        type: "error",
                        message: "请填写审批备注",
                    });
                } else {
                    let params = {
                        type: "ONLY",
                        invoiceNo: this.rowData.invoiceNo,
                        operation: "FAIL",
                        operationId:JSON.parse(sessionStorage.getItem('user_state')).userId,
                        operationName:JSON.parse(sessionStorage.getItem('user_state')).name,
                        note: this.note,
                    };
                    invoiceApi.approve(params).then((res) => {
                        if (res.succ) {
                            this.$message({
                                type: "success",
                                message: "操作成功！",
                            });
                            this.getList();
                        } else {
                            this.$message({
                                type: "error",
                                message: res.error,
                            });
                        }
                        this.dialogVisible = false;
                        this.note = "";
                    });
                }
            },

            //撤回
            withdraw(tr) {
                this.$confirm("请确认是否撤回开票？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        let params = {
                            type: "ONLY",
                            invoiceNo: tr.invoiceNo,
                            operation: "TO_INVOICED",
                            operationId: this.operationId,
                            operationName: this.operationName,
                        };
                        invoiceApi.approve(params).then((res) => {
                            if (res.succ) {
                                this.$message({
                                    type: "success",
                                    message: "操作成功！",
                                });
                                this.getList();
                            } else {
                                this.$message({
                                    type: "error",
                                    message: res.error,
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            handleSizeChange(val) {
                this.pagination.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.pagination.pageNo = val;
                this.getList();
            },
            //接收传来的条件
            getSelect(selectTJ) {
                console.log(selectTJ, "selectTJ");
                if (selectTJ.beginDate) {
                    selectTJ.beginDate = selectTJ.beginDate + " 00:00:00";
                }
                if (selectTJ.endDate) {
                    selectTJ.endDate = selectTJ.endDate + " 23:59:59";
                }

                this.selectTJ = selectTJ;
                console.log(this.selectTJ, "修改时间selectTJ");
                this.pagination.pageNo = 1;
                this.pagination.pageSize = 20;
                this.pageShow = false; //让分页隐藏
                this.$nextTick(() => {
                    //重新渲染分页
                    this.pageShow = true;
                });
                this.getList();
            },

            getEmptySearch() {
                this.selectTJ = {
                    bodyId: '',
                    beginDate: '',
                    endDate: '',
                    customerCode: '',
                    customerName: '',
                    invoiceStatus: '',
                    invoiceType: ''
                };
                this.pagination.pageNo = 1;
                this.pagination.pageSize = 20;
                this.getList();
                this.pageShow = false; //让分页隐藏
                this.$nextTick(() => {
                    //重新渲染分页
                    this.pageShow = true;
                });
            },

            //列表数据
            getList() {
                let params = {
                    pageNum: this.pagination.pageNo,
                    pageSize: this.pagination.pageSize,
                    bodyId: this.selectTJ.bodyId,
                    beginDate: this.selectTJ.beginDate?this.selectTJ.beginDate+ " 00:00:00":"",
                    endDate: this.selectTJ.endDate?this.selectTJ.endDate+ " 23:59:59":"",
                    customerCode: this.selectTJ.customerCode,
                    customerName: this.selectTJ.customerName,
                    invoiceStatus: this.selectTJ.invoiceStatus,
                    invoiceType: this.selectTJ.invoiceType,
                };
                console.log(params, "params========");
                // return false;
                invoiceApi.queryInvoiceList(params).then((res) => {
                    if (res.succ == 1) {
                        this.list = res.result.list;

                        this.pagination.totalCount = res.result.totalCount;
                        console.log(res.result, "======");
                    } else {
                        this.$notifyError(res.error);
                    }
                });
            },
        },
    };
</script>
<style lang="scss" scoped>
    .form-container{
        padding: 0 20px;
        .form-footer{
            width: 100%;
            margin-top: 50px;
            display: flex;
            .el-button{
                width: 50%;
            }
        }
    }
    .auto-box {
        max-height: 100px;
        overflow: auto;
    }
    .p1 {
        line-height: 30px;
        width: 110px;
        text-align: right;
    }
    .contentlist /deep/.vs-table {
        width: 2600px;
        .td-check {
            width: 50px;
        }
    }

    .text-centr {
        text-align: center;
    }
    .fixed-table-column {
        position: sticky;
        z-index: 999;
        right: 0px;
        box-shadow: -2px 0 2px rgba(0, 0, 0, 0.02);
        &.white {
            background-color: #fff;
        }
        &.th-back {
            background-color: #f3f2f7;
        }
    }
    .fixed-table-column {
        background: #fff;
        flex: 1;
    }
    .tabs-demo {
        width: 100%;
    }
    .wsh {
        color: #999;
    }

    .ytg {
        color: #1623d5;
    }

    .wtg {
        color: red;
    }

    .ykp {
        color: green;
    }

    .dia-box /deep/ .el-dialog__body {
        padding: 0px;
    }

    .dia-box /deep/.el-dialog__footer {
        text-align: center !important;

        .dialog-footer {
            text-align: center !important;
            margin-left: 10%;
            width: 80%;
            display: flex;
            justify-content: space-around;
        }

        .el-button {
            width: 100px;
        }
    }
</style>
<style scoped>
    .footer-page-wrapper {
        margin-right: 0px !important;
    }
</style>
